export class AutoCompleteItem {
  id: number;
  value: string;
}
